import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { AlertaService } from '../../../services/alerta.service';
import { tableModel } from '../../../components/table/model/tableModel';
import { WithholdingCatalogService } from '../../../services/withholding-catalog.service';
import { FilterWithholdingCatalog } from '../../../models/filters/filter-withholding-catalog';

@Component({
  selector: 'app-withholding',
  standalone: false,
  templateUrl: './withholding.component.html',
  styleUrl: './withholding.component.css'
})
export class WithholdingComponent {

  @ViewChild(TableComponent) withholdingsCatalogTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'},
      {columnName:'Codigo',columnValue:'attribute'},
      {columnName:'Tipo Beneficio',columnValue:'withholdingTypeDes'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterWithholdingCatalog: FilterWithholdingCatalog = new FilterWithholdingCatalog;
  advancedSearch: boolean = false;
  
  private withholdingCatalogService = inject(WithholdingCatalogService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterWithholdingCatalog = new FilterWithholdingCatalog();
    this.searchWithholdingGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchWithholdingGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/withholdingsCatalog/edit', event.id]);
  }
  addNewWithholdingGroup(){
    this.router.navigate(['/withholdingsCatalog/edit', 0]);
  }

  searchWithholdingGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchWithholdingGroupPaginator();
  }

  searchWithholdingGroupPaginator(){
    this.loading = true;

    this.withholdingCatalogService.findAllPageableWithholdingCatalog(this.filterWithholdingCatalog, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.withholdingsCatalogTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
